import type { RootState } from '@/store/root-reducer';

const selectSlice = (state: RootState) => state.linkedinCookies;

export const selectLiAt = (state: RootState) => selectSlice(state).liAt;
export const selectJsessionId = (state: RootState) => selectSlice(state).jsessionId;
export const selectCookiesUpdatedAt = (state: RootState) => selectSlice(state).cookiesUpdatedAt;
export const selectSaving = (state: RootState) => selectSlice(state).saving;

/** True until the first load settles; keeps the spinner up before/while loading. */
export const selectIsLoading = (state: RootState) => {
  const status = selectSlice(state).loadStatus;
  return status === 'idle' || status === 'loading';
};
